import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=b76907d8&"
import script from "./DetailsForm.vue?vue&type=script&lang=js&"
export * from "./DetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
